export default __webpack_public_path__ + "static/media/nuwave.97abb251.png";